function User() {
  this.user_id = '';
  this.sdkAppId = '';
  this.language = '';
  this.sdkEmail = '';
  this.sdkTel = '';
  this.sdkUid = '';
  this.sdkUserName = '';
  this.sdkToken = '';
  this.user_name = '';
  this.password = '';
  this.email = '';
  this.tel = '';
  this.openid = '';
  this.user_from = '';
  this.bind = '';
  this.new_password = '';
  this.access_token = '';
  this.birth = '';
  this.gender = '';
  this.age = '';
  this.user_type = -1;
}

User.prototype = {
  constructor: User,
};

export default User;



// WEBPACK FOOTER //
// ./src/common/js/model/User.js